// $(document).ready(function() {

//     // タイマー設定JS
//     $(".view_timer").each(function(index, target) {
//         var startDate = $(this).attr("data-start-date");
//         var endDate = $(this).attr("data-end-date");
//         var nowDate = new Date();

//         if (startDate) {
//             startDate = new Date(startDate);
//         } else {
//             startDate = nowDate;
//         }
//         if (endDate) {
//             endDate = new Date(endDate);
//         }

//         if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
//             $(this).show();
//         } else {
//             $(this).hide();
//         }
//     });

// });

$(function () {

    var body = $('body');

    //SVGスプライト
    $.ajax({
        type: 'get',
        url: '/wp/wp-content/themes/doppo/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
    }).done(function(data) {
        var svg = $(data).find('svg');
        body.prepend(svg);
    });

    // スクロールアニメーション
    $('.animate').scrolla({
        mobile: true, // モバイルの有効・無効
        once: true, // 発火は１度だけか、視界に入るたびに発火させるか
        animateCssVersion: 4 // used animate.css version (3 or 4)
    });

    //ページ内スクロール
    $.smooziee();

    //スクロールしたらクラスを付与
    $(window).scroll(function () {
        if ($(this).scrollTop() > 160) {
            body.addClass("scroll");
        } else {
            body.removeClass("scroll");
        }
    });

    //ヘッダードロップダウンメニュー
    $('.submenu_btn').on('click', function () {
        $(this).toggleClass('on');
        $(this).parents(".submenu").toggleClass('on');
        $(this).next(".submenu_wrap").toggleClass('on');
        $(".submenu_btn").not(this).removeClass("on");
        $(".submenu_btn").not(this).parents(".submenu").removeClass("on");
        $(".submenu_btn").not(this).next().removeClass("on");
        $(".submenu_btn").not(this).next().slideUp(300);
        $(this).next().slideToggle(300);
    });

    //開閉用ボタンをクリックでクラスの切替え
    $('.header_menu_btn').on('click', function () {
        body.toggleClass('open');
        // bodyにopenがあれば
        if($(body).hasClass('open')){
            $('.header_menu_btn_text').html('閉じる');
        } else {
            $('.header_menu_btn_text').html('メニュー');
        }
        return false;
    });

    //メニュー名以外の部分をクリックで閉じる
    $('.layer').on('click', function () {
        body.removeClass('open');
        // bodyにopenがあれば
        if($(body).hasClass('open')){
            $('.header_menu_btn_text').html('閉じる');
        } else {
            $('.header_menu_btn_text').html('メニュー');
        }
    });

    //アコーディオン
    if (window.matchMedia( "(max-width: 768px)" ).matches) {
        $('.acd_content').hide();
        $(".acd_ttl").on("click", function() {
            $(this).toggleClass('open');
            $(this).next().toggleClass('open');
            $(this).next().slideToggle();
        });
    }

    //サービススライド
    if (window.matchMedia( "(max-width: 768px)" ).matches) {
        var swiper = new Swiper('.service_swiper', {
            slidesPerView: 1.18,
            centeredSlides: true,
            spaceBetween: 15,
            // loop:true,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
        });
    }

    //実績紹介スライド
    if (window.matchMedia( "(max-width: 768px)" ).matches) {
        var swiper = new Swiper('.case_swiper', {
            slidesPerView: 1.13,
            centeredSlides: true,
            spaceBetween: 16,
        });
    }

    //実績リストアコーディオン
    $('.works_hide_btn').on('click',function(){
        //クリックしたボタンの親要素にクラスを付与
        $(this).toggleClass('active');
        const target = $(this).closest('.works_list_box');
        target.toggleClass('active');
        //クラスの有無で条件分岐
        if(target.hasClass('active')){
            //スクロール領域も含めた高さを取得・付与する
            const height = target.get(0).scrollHeight;
            target.css('height',height);
            //テキストを変更する
            // $(this).text('閉じる')
        }else{
            //高さを戻す
            target.css('height','');
            //テキストを戻す
            // $(this).text('実績をもっと見る(全件表示)');
        }
    });

    //採用ページ画像切り替えJS
    $(".interview_img").twentytwenty({
        no_overlay: true,
    });

    //背景画像パララックス
    const elem = document.querySelector(".parallax_up");
    if (elem !== null) {
        let target = document.getElementsByClassName("parallax_up");
            let parallaxConfig = {
                delay: 0, // スクロール止めてから動く秒数
                orientation: "up", // 動く方向
                scale: 1.5, // 動く大きさ
                overflow: true,
            };
        const parallax_instance = new simpleParallax(target, parallaxConfig);
    }

    //TOPページのみ
    if($('.home').length) {
        //TOP 事例・ノウハウパララックス
        if (window.matchMedia( "(min-width: 768px)" ).matches) {
            $('.top_casestudy .article_list >li:nth-child(odd)').addClass("rellax");
            $('.top_knowhow .article_list >li:nth-child(odd)').addClass("rellax");
            var rellax = new Rellax('.rellax', {
                speed: 4,
                center: true,
                wrapper: null,
                vertical: true,
                horizontal: false
            });
        }

        //20241227追記（works）
        o = $("#en_tvworks_top");
        new Vivus("en_tvworks_top", {
            type: "scenario-sync",
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: "inViewport"
        }, function (e) {
            o.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション mission
        // var en_mission = $("#en_mission")
        // new Vivus('en_mission', {
        //     type: 'scenario-sync',
        //     duration: 10,
        //     forceRender: false,
        //     animTimingFunction: Vivus.EASE,
        //     start: 'inViewport',
        // }, function(obj) {
        //     en_mission.parent().parent(".mission_l").addClass("vivus_end");
        //     //マーカーアニメーション mission（スマホのみ)
        //     if (window.matchMedia( "(max-width: 768px)" ).matches) {
        //         if(en_mission.parent().parent(".mission_l").hasClass('vivus_end')){
        //             var sign_mission = $("#sign_mission")
        //             new Vivus('sign_mission', {
        //                 type: 'scenario-sync',
        //                 start: 'autostart',
        //                 duration: 20,
        //                 forceRender: false,
        //                 animTimingFunction: Vivus.EASE,
        //             })
        //         }
        //     }
        // });

        //英文字アニメーション service
        var en_service = $("#en_service")
        new Vivus('en_service', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_service.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション voice
        var en_voice = $("#en_voice")
        new Vivus('en_voice', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_voice.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション casestudy
        // var en_casestudy = $("#en_casestudy")
        // new Vivus('en_casestudy', {
        //     type: 'scenario-sync',
        //     duration: 10,
        //     forceRender: false,
        //     animTimingFunction: Vivus.EASE,
        //     start: 'inViewport',
        // }, function(obj) {
        //     en_casestudy.parent().parent(".center_title").addClass("vivus_end");
        // });

        //英文字アニメーション knowhow
        // var en_knowhow = $("#en_knowhow")
        // new Vivus('en_knowhow', {
        //     type: 'scenario-sync',
        //     duration: 10,
        //     forceRender: false,
        //     animTimingFunction: Vivus.EASE,
        //     start: 'inViewport',
        // }, function(obj) {
        //     en_knowhow.parent().parent(".center_title").addClass("vivus_end");
        // });

        //英文字アニメーション member
        var en_member = $("#en_member")
        new Vivus('en_member', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_member.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション recruit
        var en_recruit = $("#en_recruit")
        new Vivus('en_recruit', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_recruit.parent().parent(".center_title").addClass("vivus_end");
            //マーカーアニメーション recruit
            if($('.recruit_top .center_title').hasClass('vivus_end')){
                var sign_recruit = $("#sign_recruit")
                setTimeout(function() {
                    new Vivus('sign_recruit', {
                        type: 'scenario-sync',
                        start: 'autostart',
                        duration: 40,
                        forceRender: false,
                        animTimingFunction: Vivus.EASE,
                    })
                }, 300);
            }
        });

        //マーカーアニメーション mission(PCのみ)
        // if (window.matchMedia( "(min-width: 768px)" ).matches) {
        //     var mission;
        //     mission = new Vivus('sign_mission', {
        //         type: 'scenario-sync',
        //         start: 'manual',
        //         duration: 10,
        //         forceRender: false,
        //         animTimingFunction:Vivus.EASE,
        //     });
        //     const sign = $(".top_mission .sign_link")
        //     $(function () {
        //         sign.hover(
        //             function () {
        //                 mission.play();
        //             },
        //             function () {
        //                 mission.play(-1);
        //             }
        //         )
        //     });
        // }

        //マーカーアニメーション 実績
        var enterprise;
        enterprise = new Vivus('sign_enterprise', {
            type: 'scenario-sync',
            start: 'inViewport',
            duration: 10,
            forceRender: false,
            animTimingFunction:Vivus.EASE,
        });
        // enterprise.play();
        // const enterpriseSign = $(".top_enterprise .ttl")
        // $(function () {
        //     enterpriseSign.hover(
        //         function () {
        //             enterprise.play();
        //         },
        //         function () {
        //             enterprise.play(-1);
        //         }
        //     )
        // });

        //マーカーアニメーション TV
        if (window.matchMedia( "(min-width: 768px)" ).matches) {
            var service_tv;
            service_tv = new Vivus('sign_service_tv', {
                type: 'scenario-sync',
                start: 'manual',
                duration: 20,
                forceRender: false,
                animTimingFunction:Vivus.EASE,
            });
            const sign = $(".service_list_tv .sign_link")
            $(function () {
                sign.hover(
                    function () {
                        service_tv.play();
                    },
                    function () {
                        service_tv.play(-1);
                    }
                )
            });
        } else {
            new Vivus('sign_service_tv', {
                type: 'scenario-sync',
                duration: 15,
                forceRender: false,
                animTimingFunction: Vivus.EASE,
            })
        }

        //マーカーアニメーション WEB
        if (window.matchMedia( "(min-width: 768px)" ).matches) {
            var service_web;
            service_web = new Vivus('sign_service_web', {
                type: 'scenario-sync',
                start: 'manual',
                duration: 20,
                forceRender: false,
                animTimingFunction:Vivus.EASE,
            });
            const sign = $(".service_list_web .sign_link")
            $(function () {
                sign.hover(
                    function () {
                        service_web.play();
                    },
                    function () {
                        service_web.play(-1);
                    }
                )
            });
        } else {
            new Vivus('sign_service_web', {
                type: 'scenario-sync',
                duration: 15,
                forceRender: false,
                animTimingFunction: Vivus.EASE,
            })
        }

        //マーカーアニメーション CG
        if (window.matchMedia( "(min-width: 768px)" ).matches) {
            var service_web;
            service_cg = new Vivus('sign_service_cg', {
                type: 'scenario-sync',
                start: 'manual',
                duration: 20,
                forceRender: false,
                animTimingFunction:Vivus.EASE,
            });
            const sign = $(".service_cg .sign_link")
            $(function () {
                sign.hover(
                    function () {
                        service_cg.play();
                    },
                    function () {
                        service_cg.play(-1);
                    }
                )
            });
        } else {
            new Vivus('sign_service_cg', {
                type: 'scenario-sync',
                duration: 15,
                forceRender: false,
                animTimingFunction: Vivus.EASE,
            })
        }



        //マーカーアニメーション 正社員エントリー
        if (window.matchMedia( "(min-width: 768px)" ).matches) {
            var entry01;
            entry01 = new Vivus('sign_entry01', {
                type: 'scenario-sync',
                start: 'manual',
                duration: 20,
                forceRender: false,
                animTimingFunction:Vivus.EASE,
            });
            const sign = $(".entry_employee a")
            $(function () {
                sign.hover(
                    function () {
                        entry01.play();
                    },
                    function () {
                        entry01.play(-1);
                    }
                )
            });
        } else {
            new Vivus('sign_entry01', {
                type: 'scenario-sync',
                duration: 15,
                forceRender: false,
                animTimingFunction: Vivus.EASE,
            })
        }

        //マーカーアニメーション 外部パートナーエントリー
        if (window.matchMedia( "(min-width: 768px)" ).matches) {
            var entry02;
            entry02 = new Vivus('sign_entry02', {
                type: 'scenario-sync',
                start: 'manual',
                duration: 20,
                forceRender: false,
                animTimingFunction:Vivus.EASE,
            });
            const sign = $(".entry_partner a")
            $(function () {
                sign.hover(
                    function () {
                        entry02.play();
                    },
                    function () {
                        entry02.play(-1);
                    }
                )
            });
        } else {
            new Vivus('sign_entry02', {
                type: 'scenario-sync',
                duration: 15,
                forceRender: false,
                animTimingFunction: Vivus.EASE,
            })
        }

        //英文字アニメーション features 20240217追記
        var en_features = $("#en_features")
        new Vivus('en_features', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_features.parent().parent(".center_title").addClass("vivus_end");
        });

    }

    //TV・WEBページのみ
    if ( ($('.tv').length) || ($('.web').length) || ($('.commercial').length) || ($('.branding').length) ) {

        //英文字アニメーション voice
        var en_voice = $("#en_voice")
        new Vivus('en_voice', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_voice.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション features
        var en_features = $("#en_features")
        new Vivus('en_features', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_features.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション be_a_unique
        // var en_unique = $("#en_unique")
        // new Vivus('en_unique', {
        //     type: 'scenario-sync',
        //     duration: 10,
        //     forceRender: false,
        //     animTimingFunction: Vivus.EASE,
        //     start: 'inViewport',
        // }, function(obj) {
        //     en_unique.parent("li").addClass("vivus_end");
        // });

        //英文字アニメーション be_a_positive
        // var en_positive = $("#en_positive")
        // new Vivus('en_positive', {
        //     type: 'scenario-sync',
        //     duration: 7,
        //     forceRender: false,
        //     animTimingFunction: Vivus.EASE,
        //     start: 'inViewport',
        // }, function(obj) {
        //     en_positive.parent("li").addClass("vivus_end");
        // });

        //英文字アニメーション be_a_pro
        // var en_pro = $("#en_pro")
        // new Vivus('en_pro', {
        //     type: 'scenario-sync',
        //     duration: 14,
        //     forceRender: false,
        //     animTimingFunction: Vivus.EASE,
        //     start: 'inViewport',
        // }, function(obj) {
        //     en_pro.parent("li").addClass("vivus_end");
        // });

        //英文字アニメーション be_a_bold
        // var en_bold = $("#en_bold")
        // new Vivus('en_bold', {
        //     type: 'scenario-sync',
        //     duration: 12,
        //     forceRender: false,
        //     animTimingFunction: Vivus.EASE,
        //     start: 'inViewport',
        // }, function(obj) {
        //     en_bold.parent("li").addClass("vivus_end");
        // });

        //英文字アニメーション be_a_modest
        // var en_modest = $("#en_modest")
        // new Vivus('en_modest', {
        //     type: 'scenario-sync',
        //     duration: 10,
        //     forceRender: false,
        //     animTimingFunction: Vivus.EASE,
        //     start: 'inViewport',
        // }, function(obj) {
        //     en_modest.parent("li").addClass("vivus_end");
        // });

        //英文字アニメーション casestudy
        var en_casestudy = $("#en_casestudy")
        new Vivus('en_casestudy', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_casestudy.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション flow
        var en_flow = $("#en_flow")
        new Vivus('en_flow', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_flow.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション knowhow
        var en_knowhow = $("#en_knowhow")
        new Vivus('en_knowhow', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_knowhow.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション faq
        var en_faq = $("#en_faq")
        new Vivus('en_faq', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_faq.parent().parent(".center_title").addClass("vivus_end");
        });
    }

    //TVページのみ（インフォマーシャル／通販番組の企画制作）
    if ( ($('.tv').length) || ($('.commercial').length) ) {
        //英文字アニメーション service
        var en_service = $("#en_service")
        new Vivus('en_service', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_service.parent().parent(".service_top_l").addClass("vivus_end");
            //マーカーアニメーション service
            if(en_service.parent().parent(".service_top_l").hasClass('vivus_end')){
                var sign_service_tv_page = $("#sign_service_tv_page")
                new Vivus('sign_service_tv_page', {
                    type: 'scenario-sync',
                    start: 'autostart',
                    duration: 50,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        });

        //英文字アニメーション tvworks
        var en_tvworks = $("#en_tvworks")
        new Vivus('en_tvworks', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_tvworks.parent().parent(".center_title").addClass("vivus_end");
        });

        //インフォマ件数動的表示
        var info_kazu = $(".info_works_list li").length;
        var info_text = "実績をもっと見る(全"+info_kazu+"件)";
        $(".works_info_btn").attr('data-item',info_text);

        //TV-CM件数動的表示
        var cm_kazu = $(".cm_works_list li").length;
        var cm_text = "実績をもっと見る(全"+cm_kazu+"件)";
        $(".works_cm_btn").attr('data-item',cm_text);

        //商談・営業ツール件数動的表示
        var shoudan_kazu = $(".shoudan_works_list li").length;
        var shoudan_text = "実績をもっと見る(全"+shoudan_kazu+"件)";
        $(".works_shoudan_btn").attr('data-item',shoudan_text);

    }

    //WEBページのみ（ブランディング）
    if ( ($('.web').length) || ($('.branding').length) ) {
    // if ( $('.web').length) {
        //英文字アニメーション service
        var en_service = $("#en_service")
        new Vivus('en_service', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_service.parent().parent(".service_top_l").addClass("vivus_end");
            //マーカーアニメーション service
            if(en_service.parent().parent(".service_top_l").hasClass('vivus_end')){
                var sign_service_web_page = $("#sign_service_web_page")
                new Vivus('sign_service_web_page', {
                    type: 'scenario-sync',
                    start: 'autostart',
                    duration: 60,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        });

        //英文字アニメーション webworks
        var en_webworks = $("#en_webworks")
        new Vivus('en_webworks', {
            type: 'scenario-sync',
            duration: 8,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_webworks.parent().parent(".center_title").addClass("vivus_end");
        });

        //実績件数動的表示
        var branding_kazu = $(".branding_works_list li").length;
        var branding_text = "実績をもっと見る(全"+branding_kazu+"件)";
        $(".works_branding_btn").attr('data-item',branding_text);


    }

    //特長ページのみ
    if ( $('.about').length) {
        //英文字アニメーション about
        var en_about = $("#en_about")
        new Vivus('en_about', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_about.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });

        //英文字アニメーション three_promises
        var en_three_promises = $("#en_three_promises")
        new Vivus('en_three_promises', {
            type: 'scenario-sync',
            duration: 8,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_three_promises.parent().parent(".about_title").addClass("vivus_end");
        });

        //英文字アニメーション six_features
        var en_six_features = $("#en_six_features")
        new Vivus('en_six_features', {
            type: 'scenario-sync',
            duration: 8,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_six_features.parent().parent(".about_title").addClass("vivus_end");
        });

        //英文字アニメーション style
        var en_style = $("#en_style")
        new Vivus('en_style', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_style.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション member
        var en_member_black = $("#en_member_black")
        new Vivus('en_member_black', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_member_black.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション company
        var en_company = $("#en_company")
        new Vivus('en_company', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_company.parent().parent(".center_title").addClass("vivus_end");
        });

        //マーカーアニメーション 3つの約束
        new Vivus('sign_promises', {
            type: 'scenario-sync',
            duration: 30,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        })

        //マーカーアニメーション 6つの特長
        new Vivus('sign_sixfeatures', {
            type: 'scenario-sync',
            duration: 30,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        })

        //マーカーアニメーション 会社案内
        new Vivus('sign_company', {
            type: 'scenario-sync',
            duration: 60,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        })
    }

    //メンバーページのみ
    if ( $('.member').length) {
        //英文字アニメーション member
        var en_member = $("#en_member")
        new Vivus('en_member', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_member.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });

        //マーカーアニメーション Doppoの誇り
        new Vivus('sign_member', {
            type: 'scenario-sync',
            duration: 30,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        })
    }

    //会社案内ーページのみ
    if ( $('.company').length) {
        //英文字アニメーション company
        var en_company_white = $("#en_company_white")
        new Vivus('en_company_white', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_company_white.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });

        //英文字アニメーション aboutus
        var en_aboutus = $("#en_aboutus")
        new Vivus('en_aboutus', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_aboutus.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション outline
        var en_outline = $("#en_outline")
        new Vivus('en_outline', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_outline.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション history
        var en_history = $("#en_history")
        new Vivus('en_history', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_history.parent().parent(".center_title").addClass("vivus_end");
        });

        //英文字アニメーション mainclients
        var en_mainclients = $("#en_mainclients")
        new Vivus('en_mainclients', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_mainclients.parent().parent(".center_title").addClass("vivus_end");
        });

        //マーカーアニメーション PHILOSOPHY
        new Vivus('sign_philosophy', {
            type: 'scenario-sync',
            duration: 30,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        })
    }

    //お客様の声ページのみ
    if ( $('.voice').length) {
        //英文字アニメーション voice
        var en_voice = $("#en_voice")
        new Vivus('en_voice', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_voice.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });

        //マーカーアニメーション 01
        var sign_voice_01 = $("#sign_voice_01")
        setTimeout(function() {
            sign_voice_01 = new Vivus('sign_voice_01', {
                type: 'scenario-sync',
                start: 'inViewport',
                duration: 60,
                forceRender: false,
                animTimingFunction: Vivus.EASE,
            });
        }, 0);  // 2秒の遅延

        //マーカーアニメーション 02
        var sign_voice_02;
        setTimeout(function() {
            sign_voice_02 = new Vivus('sign_voice_02', {
                type: 'scenario-sync',
                start: 'inViewport',
                duration: 60,
                forceRender: false,
                animTimingFunction: Vivus.EASE,
            });
        }, 500);  // 2秒の遅延
    
        //マーカーアニメーション 03
        var sign_voice_03;
        setTimeout(function() {
            sign_voice_03 = new Vivus('sign_voice_03', {
                type: 'scenario-sync',
                start: 'inViewport',
                duration: 60,
                forceRender: false,
                animTimingFunction: Vivus.EASE,
            });
        }, 500);  // 2秒の遅延

    }

    //採用情報ページのみ
    if ( $('.recruit').length) {
        //英文字アニメーション be_a_unique
        var en_unique = $("#en_unique")
        new Vivus('en_unique', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_unique.parent("li").addClass("vivus_end");
        });

        //英文字アニメーション be_a_positive
        var en_positive = $("#en_positive")
        new Vivus('en_positive', {
            type: 'scenario-sync',
            duration: 7,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_positive.parent("li").addClass("vivus_end");
        });

        //英文字アニメーション be_a_pro
        var en_pro = $("#en_pro")
        new Vivus('en_pro', {
            type: 'scenario-sync',
            duration: 14,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_pro.parent("li").addClass("vivus_end");
        });

        //英文字アニメーション be_a_bold
        var en_bold = $("#en_bold")
        new Vivus('en_bold', {
            type: 'scenario-sync',
            duration: 12,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_bold.parent("li").addClass("vivus_end");
        });

        //英文字アニメーション be_a_modest
        var en_modest = $("#en_modest")
        new Vivus('en_modest', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_modest.parent("li").addClass("vivus_end");
        });
    }

    //採用トピックスページのみ
    if ( $('.post-type-archive-recruit-topics').length) {
        //英文字アニメーション recruit_topics
        var en_recruit_topics = $("#en_recruit_topics")
        new Vivus('en_recruit_topics', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_recruit_topics.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });
    }

    // 事例紹介ページのみ
    if ( ($('.post-type-archive-casestudy').length) || ($('.tax-cat_casestudy').length) ) {
        //英文字アニメーション casestudy
        var en_casestudy_white = $("#en_casestudy_white")
        new Vivus('en_casestudy_white', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_casestudy_white.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });
    }

    //ノウハウページのみ
    if ( ($('.post-type-archive-column').length) || ($('.tax-cat_column').length) ) {
        //英文字アニメーション knowhow　column
        var en_knowhow_white = $("#en_knowhow_white")
        new Vivus('en_knowhow_white', {
            type: 'oneByOne',
            duration: 50,
            forceRender: true,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_knowhow_white.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });
    }

    //御見積・お問い合わせページのみ
    if ( ($('.contact').length) || ($('.contact-child').length) ) {
        //英文字アニメーション contact
        var en_contact = $("#en_contact")
        new Vivus('en_contact', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_contact.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });
    }

    //外部パートナーページのみ
    if ( ($('.partner').length) || ($('.partner-child').length) ) {
        //英文字アニメーション partner
        var en_partner = $("#en_partner")
        new Vivus('en_partner', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_partner.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });
    }

    //個人情報保護方針ページのみ
    if($('.privacy').length) {
        //英文字アニメーション privacy
        var en_privacy = $("#en_privacy")
        new Vivus('en_privacy', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_privacy.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });
    }

    //よくあるご質問ページのみ
    if($('.faq').length) {
        //英文字アニメーション faq
        var en_faq_white = $("#en_faq_white")
        new Vivus('en_faq_white', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_faq_white.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });
    }

    //ESGページのみ
    if($('.esg').length) {
        //英文字アニメーション faq
        var en_esg_white = $("#en_esg_white")
        new Vivus('en_esg_white', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_esg_white.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });
    }

    //お知らせページのみ
    if($('.blog').length) {
        //英文字アニメーション news
        var en_news = $("#en_news")
        new Vivus('en_news', {
            type: 'scenario-sync',
            duration: 10,
            forceRender: false,
            animTimingFunction: Vivus.EASE,
            start: 'inViewport',
        }, function(obj) {
            en_news.parent().parent(".mv_ttl_en").addClass("vivus_end");
        });

        //マーカーアニメーション

        //1つ目
        if ( $('#sign_blog1').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog1;
                blog1 = new Vivus('sign_blog1', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign1 = $(".article_blog1 > a")
                $(function () {
                    sign1.hover(
                        function () {
                            blog1.play();
                        },
                        function () {
                            blog1.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog1', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //2つ目
        if ( $('#sign_blog2').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog2;
                blog2 = new Vivus('sign_blog2', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign2 = $(".article_blog2 > a")
                $(function () {
                    sign2.hover(
                        function () {
                            blog2.play();
                        },
                        function () {
                            blog2.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog2', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //3つ目
        if ( $('#sign_blog3').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog3;
                blog3 = new Vivus('sign_blog3', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign3 = $(".article_blog3 > a")
                $(function () {
                    sign3.hover(
                        function () {
                            blog3.play();
                        },
                        function () {
                            blog3.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog3', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //4つ目
        if ( $('#sign_blog4').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog4;
                blog4 = new Vivus('sign_blog4', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign4 = $(".article_blog4 > a")
                $(function () {
                    sign4.hover(
                        function () {
                            blog4.play();
                        },
                        function () {
                            blog4.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog4', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //5つ目
        if ( $('#sign_blog5').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog5;
                blog5 = new Vivus('sign_blog5', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign5 = $(".article_blog5 > a")
                $(function () {
                    sign5.hover(
                        function () {
                            blog5.play();
                        },
                        function () {
                            blog5.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog5', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //6つ目
        if ( $('#sign_blog6').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog6;
                blog6 = new Vivus('sign_blog6', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign6 = $(".article_blog6 > a")
                $(function () {
                    sign6.hover(
                        function () {
                            blog6.play();
                        },
                        function () {
                            blog6.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog6', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //7つ目
        if ( $('#sign_blog7').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog7;
                blog7 = new Vivus('sign_blog7', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign7 = $(".article_blog7 > a")
                $(function () {
                    sign7.hover(
                        function () {
                            blog7.play();
                        },
                        function () {
                            blog7.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog7', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //8つ目
        if ( $('#sign_blog8').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog8;
                blog8 = new Vivus('sign_blog8', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign8 = $(".article_blog8 > a")
                $(function () {
                    sign8.hover(
                        function () {
                            blog8.play();
                        },
                        function () {
                            blog8.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog8', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //9つ目
        if ( $('#sign_blog9').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog9;
                blog9 = new Vivus('sign_blog9', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign9 = $(".article_blog9 > a")
                $(function () {
                    sign9.hover(
                        function () {
                            blog9.play();
                        },
                        function () {
                            blog9.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog9', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //10つ目
        if ( $('#sign_blog10').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog10;
                blog10 = new Vivus('sign_blog10', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign10 = $(".article_blog10 > a")
                $(function () {
                    sign10.hover(
                        function () {
                            blog10.play();
                        },
                        function () {
                            blog10.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog10', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //11つ目
        if ( $('#sign_blog11').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog11;
                blog11 = new Vivus('sign_blog11', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign11 = $(".article_blog11 > a")
                $(function () {
                    sign11.hover(
                        function () {
                            blog11.play();
                        },
                        function () {
                            blog11.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog11', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //12つ目
        if ( $('#sign_blog12').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog12;
                blog12 = new Vivus('sign_blog12', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign12 = $(".article_blog12 > a")
                $(function () {
                    sign12.hover(
                        function () {
                            blog12.play();
                        },
                        function () {
                            blog12.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog12', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //13つ目
        if ( $('#sign_blog13').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog13;
                blog13 = new Vivus('sign_blog13', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign13 = $(".article_blog13 > a")
                $(function () {
                    sign13.hover(
                        function () {
                            blog13.play();
                        },
                        function () {
                            blog13.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog13', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //14つ目
        if ( $('#sign_blog14').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog14;
                blog14 = new Vivus('sign_blog14', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign14 = $(".article_blog14 > a")
                $(function () {
                    sign14.hover(
                        function () {
                            blog14.play();
                        },
                        function () {
                            blog14.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog14', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //15つ目
        if ( $('#sign_blog15').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var blog15;
                blog15 = new Vivus('sign_blog15', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign15 = $(".article_blog15 > a")
                $(function () {
                    sign15.hover(
                        function () {
                            blog15.play();
                        },
                        function () {
                            blog15.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_blog15', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
    }

    //TOP・TV・WEB・事例ページ
    if ( ($('.home').length) || ($('.commercial').length) || ($('.branding').length) || ($('.post-type-archive-casestudy').length) || ($('.tax-cat_casestudy').length) ) {

        //マーカーアニメーション 事例

        //1つ目
        if ( $('#sign_casestudy1').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy1;
                casestudy1 = new Vivus('sign_casestudy1', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign1 = $(".article_casestudy1 > a")
                $(function () {
                    sign1.hover(
                        function () {
                            casestudy1.play();
                        },
                        function () {
                            casestudy1.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy1', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //2つ目
        if ( $('#sign_casestudy2').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy2;
                casestudy2 = new Vivus('sign_casestudy2', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign2 = $(".article_casestudy2 > a")
                $(function () {
                    sign2.hover(
                        function () {
                            casestudy2.play();
                        },
                        function () {
                            casestudy2.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy2', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //3つ目
        if ( $('#sign_casestudy3').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy3;
                casestudy3 = new Vivus('sign_casestudy3', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign3 = $(".article_casestudy3 > a")
                $(function () {
                    sign3.hover(
                        function () {
                            casestudy3.play();
                        },
                        function () {
                            casestudy3.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy3', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //4つ目
        if ( $('#sign_casestudy4').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy4;
                casestudy4 = new Vivus('sign_casestudy4', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign4 = $(".article_casestudy4 > a")
                $(function () {
                    sign4.hover(
                        function () {
                            casestudy4.play();
                        },
                        function () {
                            casestudy4.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy4', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //5つ目
        if ( $('#sign_casestudy5').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy5;
                casestudy5 = new Vivus('sign_casestudy5', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign5 = $(".article_casestudy5 > a")
                $(function () {
                    sign5.hover(
                        function () {
                            casestudy5.play();
                        },
                        function () {
                            casestudy5.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy5', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //6つ目
        if ( $('#sign_casestudy6').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy6;
                casestudy6 = new Vivus('sign_casestudy6', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign6 = $(".article_casestudy6 > a")
                $(function () {
                    sign6.hover(
                        function () {
                            casestudy6.play();
                        },
                        function () {
                            casestudy6.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy6', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //7つ目
        if ( $('#sign_casestudy7').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy7;
                casestudy7 = new Vivus('sign_casestudy7', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign7 = $(".article_casestudy7 > a")
                $(function () {
                    sign7.hover(
                        function () {
                            casestudy7.play();
                        },
                        function () {
                            casestudy7.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy7', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //8つ目
        if ( $('#sign_casestudy8').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy8;
                casestudy8 = new Vivus('sign_casestudy8', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign8 = $(".article_casestudy8 > a")
                $(function () {
                    sign8.hover(
                        function () {
                            casestudy8.play();
                        },
                        function () {
                            casestudy8.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy8', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //9つ目
        if ( $('#sign_casestudy9').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy9;
                casestudy9 = new Vivus('sign_casestudy9', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign9 = $(".article_casestudy9 > a")
                $(function () {
                    sign9.hover(
                        function () {
                            casestudy9.play();
                        },
                        function () {
                            casestudy9.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy9', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //10個目
        if ( $('#sign_casestudy10').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy10;
                casestudy10 = new Vivus('sign_casestudy10', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign10 = $(".article_casestudy10 > a")
                $(function () {
                    sign10.hover(
                        function () {
                            casestudy10.play();
                        },
                        function () {
                            casestudy10.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy10', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //11個目
        if ( $('#sign_casestudy11').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy11;
                casestudy11 = new Vivus('sign_casestudy11', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign11 = $(".article_casestudy11 > a")
                $(function () {
                    sign11.hover(
                        function () {
                            casestudy11.play();
                        },
                        function () {
                            casestudy11.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy11', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //12個目
        if ( $('#sign_casestudy12').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy12;
                casestudy12 = new Vivus('sign_casestudy12', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign12 = $(".article_casestudy12 > a")
                $(function () {
                    sign12.hover(
                        function () {
                            casestudy12.play();
                        },
                        function () {
                            casestudy12.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy12', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //13個目
        if ( $('#sign_casestudy13').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy13;
                casestudy13 = new Vivus('sign_casestudy13', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign13 = $(".article_casestudy13 > a")
                $(function () {
                    sign13.hover(
                        function () {
                            casestudy13.play();
                        },
                        function () {
                            casestudy13.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy13', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //14個目
        if ( $('#sign_casestudy14').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy14;
                casestudy14 = new Vivus('sign_casestudy14', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign14 = $(".article_casestudy14 > a")
                $(function () {
                    sign14.hover(
                        function () {
                            casestudy14.play();
                        },
                        function () {
                            casestudy14.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy14', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //15個目
        if ( $('#sign_casestudy15').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var casestudy15;
                casestudy15 = new Vivus('sign_casestudy15', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign15 = $(".article_casestudy15 > a")
                $(function () {
                    sign15.hover(
                        function () {
                            casestudy15.play();
                        },
                        function () {
                            casestudy15.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_casestudy15', {
                    type: 'scenario-sync',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }

    }

    //TOP・TV・WEB・コラムページ
    if ( ($('.home').length) || ($('.commercial').length) || ($('.branding').length) || ($('.post-type-archive-column').length) || ($('.tax-cat_column').length) ) {
        //マーカーアニメーション ノウハウ

        //1個目
        if ( $('#sign_knowhow1').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow1;
                knowhow1 = new Vivus('sign_knowhow1', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow1 = $(".article_knowhow1 > a")
                $(function () {
                    sign_knowhow1.hover(
                        function () {
                            knowhow1.play();
                        },
                        function () {
                            knowhow1.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow1', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //2個目
        if ( $('#sign_knowhow2').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow2;
                knowhow2 = new Vivus('sign_knowhow2', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow2 = $(".article_knowhow2 > a")
                $(function () {
                    sign_knowhow2.hover(
                        function () {
                            knowhow2.play();
                        },
                        function () {
                            knowhow2.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow2', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //3個目
        if ( $('#sign_knowhow3').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow3;
                knowhow3 = new Vivus('sign_knowhow3', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow3 = $(".article_knowhow3 > a")
                $(function () {
                    sign_knowhow3.hover(
                        function () {
                            knowhow3.play();
                        },
                        function () {
                            knowhow3.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow3', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //4個目
        if ( $('#sign_knowhow4').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow4;
                knowhow4 = new Vivus('sign_knowhow4', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow4 = $(".article_knowhow4 > a")
                $(function () {
                    sign_knowhow4.hover(
                        function () {
                            knowhow4.play();
                        },
                        function () {
                            knowhow4.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow4', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //5個目
        if ( $('#sign_knowhow5').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow5;
                knowhow5 = new Vivus('sign_knowhow5', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow5 = $(".article_knowhow5 > a")
                $(function () {
                    sign_knowhow5.hover(
                        function () {
                            knowhow5.play();
                        },
                        function () {
                            knowhow5.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow5', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //6個目
        if ( $('#sign_knowhow6').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow6;
                knowhow6 = new Vivus('sign_knowhow6', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow6 = $(".article_knowhow6 > a")
                $(function () {
                    sign_knowhow6.hover(
                        function () {
                            knowhow6.play();
                        },
                        function () {
                            knowhow6.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow6', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //7個目
        if ( $('#sign_knowhow7').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow7;
                knowhow7 = new Vivus('sign_knowhow7', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow7 = $(".article_knowhow7 > a")
                $(function () {
                    sign_knowhow7.hover(
                        function () {
                            knowhow7.play();
                        },
                        function () {
                            knowhow7.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow7', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //8個目
        if ( $('#sign_knowhow8').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow8;
                knowhow8 = new Vivus('sign_knowhow8', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow8 = $(".article_knowhow8 > a")
                $(function () {
                    sign_knowhow8.hover(
                        function () {
                            knowhow8.play();
                        },
                        function () {
                            knowhow8.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow8', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //9個目
        if ( $('#sign_knowhow9').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow9;
                knowhow9 = new Vivus('sign_knowhow9', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow9 = $(".article_knowhow9 > a")
                $(function () {
                    sign_knowhow9.hover(
                        function () {
                            knowhow9.play();
                        },
                        function () {
                            knowhow9.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow9', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //10個目
        if ( $('#sign_knowhow10').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow10;
                knowhow10 = new Vivus('sign_knowhow10', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow10 = $(".article_knowhow10 > a")
                $(function () {
                    sign_knowhow10.hover(
                        function () {
                            knowhow10.play();
                        },
                        function () {
                            knowhow10.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow10', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //11個目
        if ( $('#sign_knowhow11').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow11;
                knowhow11 = new Vivus('sign_knowhow11', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow11 = $(".article_knowhow11 > a")
                $(function () {
                    sign_knowhow11.hover(
                        function () {
                            knowhow11.play();
                        },
                        function () {
                            knowhow11.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow11', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //12個目
        if ( $('#sign_knowhow12').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow12;
                knowhow12 = new Vivus('sign_knowhow12', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow12 = $(".article_knowhow12 > a")
                $(function () {
                    sign_knowhow12.hover(
                        function () {
                            knowhow12.play();
                        },
                        function () {
                            knowhow12.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow12', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //13個目
        if ( $('#sign_knowhow13').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow13;
                knowhow13 = new Vivus('sign_knowhow13', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow13 = $(".article_knowhow13 > a")
                $(function () {
                    sign_knowhow13.hover(
                        function () {
                            knowhow13.play();
                        },
                        function () {
                            knowhow13.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow13', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //14個目
        if ( $('#sign_knowhow14').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow14;
                knowhow14 = new Vivus('sign_knowhow14', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow14 = $(".article_knowhow14 > a")
                $(function () {
                    sign_knowhow14.hover(
                        function () {
                            knowhow14.play();
                        },
                        function () {
                            knowhow14.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow14', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //15個目
        if ( $('#sign_knowhow15').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var knowhow15;
                knowhow15 = new Vivus('sign_knowhow15', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 20,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_knowhow15 = $(".article_knowhow15 > a")
                $(function () {
                    sign_knowhow15.hover(
                        function () {
                            knowhow15.play();
                        },
                        function () {
                            knowhow15.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_knowhow15', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }

    }

    //採用・採用トピックスページ
    if ( ($('.recruit').length) || ($('.post-type-archive-recruit-topics').length) ) {
        //マーカーアニメーション 事例

        //1個目
        if ( $('#sign_recruit_topics1').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics1;
                recruit_topics1 = new Vivus('sign_recruit_topics1', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics1 = $(".article_recruit_topics1 > a")
                $(function () {
                    sign_topics1.hover(
                        function () {
                            recruit_topics1.play();
                        },
                        function () {
                            recruit_topics1.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics1', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //2個目
        if ( $('#sign_recruit_topics2').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics2;
                recruit_topics2 = new Vivus('sign_recruit_topics2', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics2 = $(".article_recruit_topics2 > a")
                $(function () {
                    sign_topics2.hover(
                        function () {
                            recruit_topics2.play();
                        },
                        function () {
                            recruit_topics2.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics2', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //3個目
        if ( $('#sign_recruit_topics3').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics3;
                recruit_topics3 = new Vivus('sign_recruit_topics3', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics3 = $(".article_recruit_topics3 > a")
                $(function () {
                    sign_topics3.hover(
                        function () {
                            recruit_topics3.play();
                        },
                        function () {
                            recruit_topics3.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics3', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //4個目
        if ( $('#sign_recruit_topics4').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics4;
                recruit_topics4 = new Vivus('sign_recruit_topics4', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics4 = $(".article_recruit_topics4 > a")
                $(function () {
                    sign_topics4.hover(
                        function () {
                            recruit_topics4.play();
                        },
                        function () {
                            recruit_topics4.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics4', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //5個目
        if ( $('#sign_recruit_topics5').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics5;
                recruit_topics5 = new Vivus('sign_recruit_topics5', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics5 = $(".article_recruit_topics5 > a")
                $(function () {
                    sign_topics5.hover(
                        function () {
                            recruit_topics5.play();
                        },
                        function () {
                            recruit_topics5.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics5', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //6個目
        if ( $('#sign_recruit_topics6').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics6;
                recruit_topics6 = new Vivus('sign_recruit_topics6', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics6 = $(".article_recruit_topics6 > a")
                $(function () {
                    sign_topics6.hover(
                        function () {
                            recruit_topics6.play();
                        },
                        function () {
                            recruit_topics6.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics6', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //7個目
        if ( $('#sign_recruit_topics7').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics7;
                recruit_topics7 = new Vivus('sign_recruit_topics7', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics7 = $(".article_recruit_topics7 > a")
                $(function () {
                    sign_topics7.hover(
                        function () {
                            recruit_topics7.play();
                        },
                        function () {
                            recruit_topics7.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics7', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //8個目
        if ( $('#sign_recruit_topics8').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics8;
                recruit_topics8 = new Vivus('sign_recruit_topics8', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics8 = $(".article_recruit_topics8 > a")
                $(function () {
                    sign_topics8.hover(
                        function () {
                            recruit_topics8.play();
                        },
                        function () {
                            recruit_topics8.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics8', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //9個目
        if ( $('#sign_recruit_topics9').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics9;
                recruit_topics9 = new Vivus('sign_recruit_topics9', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics9 = $(".article_recruit_topics9 > a")
                $(function () {
                    sign_topics9.hover(
                        function () {
                            recruit_topics9.play();
                        },
                        function () {
                            recruit_topics9.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics9', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //10個目
        if ( $('#sign_recruit_topics10').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics10;
                recruit_topics10 = new Vivus('sign_recruit_topics10', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics10 = $(".article_recruit_topics10 > a")
                $(function () {
                    sign_topics10.hover(
                        function () {
                            recruit_topics10.play();
                        },
                        function () {
                            recruit_topics10.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics10', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //11個目
        if ( $('#sign_recruit_topics11').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics11;
                recruit_topics11 = new Vivus('sign_recruit_topics11', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics11 = $(".article_recruit_topics11 > a")
                $(function () {
                    sign_topics11.hover(
                        function () {
                            recruit_topics11.play();
                        },
                        function () {
                            recruit_topics11.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics11', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //12個目
        if ( $('#sign_recruit_topics12').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics12;
                recruit_topics12 = new Vivus('sign_recruit_topics12', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics12 = $(".article_recruit_topics12 > a")
                $(function () {
                    sign_topics12.hover(
                        function () {
                            recruit_topics12.play();
                        },
                        function () {
                            recruit_topics12.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics12', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //13個目
        if ( $('#sign_recruit_topics13').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics13;
                recruit_topics13 = new Vivus('sign_recruit_topics13', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics13 = $(".article_recruit_topics13 > a")
                $(function () {
                    sign_topics13.hover(
                        function () {
                            recruit_topics13.play();
                        },
                        function () {
                            recruit_topics13.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics13', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //14個目
        if ( $('#sign_recruit_topics14').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics14;
                recruit_topics14 = new Vivus('sign_recruit_topics14', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics14 = $(".article_recruit_topics14 > a")
                $(function () {
                    sign_topics14.hover(
                        function () {
                            recruit_topics14.play();
                        },
                        function () {
                            recruit_topics14.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics14', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
        //15個目
        if ( $('#sign_recruit_topics15').length) {
            if (window.matchMedia( "(min-width: 768px)" ).matches) {
                var recruit_topics15;
                recruit_topics15 = new Vivus('sign_recruit_topics15', {
                    type: 'scenario-sync',
                    start: 'manual',
                    duration: 30,
                    forceRender: false,
                    animTimingFunction:Vivus.EASE,
                });
                const sign_topics15 = $(".article_recruit_topics15 > a")
                $(function () {
                    sign_topics15.hover(
                        function () {
                            recruit_topics15.play();
                        },
                        function () {
                            recruit_topics15.play(-1);
                        }
                    )
                });
            } else {
                new Vivus('sign_recruit_topics15', {
                    type: 'scenario-sync',
                    duration: 15,
                    forceRender: false,
                    animTimingFunction: Vivus.EASE,
                })
            }
        }
    }

    //FAQアコーディオン
    $window = $(window);
    //アコーディオンメニューの実装
    $(".toggle_content").hide();
    $(".toggle_trigger").on('click', function () {
        var $thisElm = $(this),
            $activeElm = $(".toggle_trigger.active"),
            currentScrollTop = $window.scrollTop(),
            posTop = $thisElm.offset().top,
            currentPosTop = posTop;
        if(!($thisElm.hasClass("active"))) {
          $activeElm.removeClass("active");
          $activeElm.next(".toggle_content").slideUp();
          $thisElm.addClass("active");
          $thisElm.next(".toggle_content").slideDown({
            step: function() { //各ステップごとに、移動分スクロールさせる
              currentPosTop = $thisElm.offset().top;
              $("html,body").animate({
                "scrollTop": currentScrollTop - (posTop - currentPosTop) //スクロールを実行
              }, 0);
            }
          });
        } else {
          $activeElm.removeClass("active");
          $activeElm.next(".toggle_content").slideUp();
          $thisElm.next(".toggle_content").slideUp({
            step: function() { //各ステップごとに、移動分スクロールさせる
              currentPosTop = $thisElm.offset().top;
              $("html,body").animate({
                "scrollTop": currentScrollTop - (posTop - currentPosTop) //スクロールを実行
              }, 0);
            }
          });
        }
    });
    $('.toggle_close').on('click', function () {
        $(this).parent(".toggle_content").prev(".toggle_trigger").removeClass('active');
        $(this).parent(".toggle_content").removeClass('active');
        $(this).parent(".toggle_content").slideUp();
        var position = $(this).parent(".toggle_content").prev(".toggle_trigger").offset().top;
        console.log(position);
        $("html,body").animate({
            scrollTop : position - 150 //スクロール位置調整
        });
    });

    //ポップアップ表示
    $('[data-fancybox]').fancybox(
      {
        infobar  : true,
        buttons : [
        'close'
    ],
     baseTpl :
      '<div class="fancybox-container" role="dialog" tabindex="-1">' +
      '<div class="fancybox-bg"></div>' +
      '<div class="fancybox-inner">' +
      '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;of&nbsp;<span data-fancybox-count></span></div>' +
      '<div class="fancybox-toolbar">{{buttons}}</div>' +
      '<div class="fancybox-navigation">{{arrows}}</div>' +
      '<div class="fancybox-stage"></div>' +
      '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
      '</div>' +
      '</div>',
      video: {
              tpl:
                '<video class="fancybox-video" controls controlsList="nodownload">' +
                '<source src="{{src}}" type="{{format}}" />' +
                'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
                "</video>",
              format: "", // custom video format
              autoStart: true
            },
    });

});